import React from "react";
import { SaftiLogo } from "./SaftiLogo";
import { navLinks } from "../data/content";
export function Footer() {
  return <footer className="bg-ink text-white" data-id="element-120" data-mp="3gg0za3iktxxn">
      <div className="mx-auto max-w-[1400px] px-5 pb-10 pt-20 md:px-10" data-id="element-121" data-mp="32nukakr5twzs">
        <p className="text-[48px] font-semibold leading-[0.95] tracking-[-0.045em] sm:text-[80px] lg:text-[136px]" data-id="element-122" data-mp="32pp4txyirn3c">
          Votre avenir <span className="font-serif font-normal italic text-brand" data-id="element-123" data-mp="3uf0mr7ucs6s8">commence ici.</span>
        </p>
        <div className="mt-20 flex flex-col gap-8 border-t border-white/15 pt-8 md:flex-row md:items-center md:justify-between" data-id="element-124" data-mp="38qtcrvhxfo0">
          <div className="flex items-center gap-4" data-id="element-125" data-mp="3lf5bl30ssbs7">
            <SaftiLogo light data-id="element-126" data-mp="3lgooqkr5q6pr" />
            <span className="text-[12px] uppercase tracking-[0.3em] text-white/60" data-id="element-127" data-mp="3qcxa4fvy6w5d">Infiny Team</span>
          </div>
          <nav aria-label="Pied de page" className="flex flex-wrap gap-6 text-[14px] text-white/70" data-id="element-128" data-mp="29y5i442prqwl">
            {navLinks.map(l => <a key={l.href} href={l.href} className="transition-colors duration-150 hover:text-white" data-id="element-129" data-mp="2ew6zmkkhri5y">
                {l.label}
              </a>)}
            <a href="#" className="transition-colors duration-150 hover:text-white" data-id="element-130" data-mp="3gbilwpom1k0r">
              Mentions légales
            </a>
          </nav>
          <p className="text-[13px] text-white/50" data-id="element-131" data-mp="3v5dfkog732rd">© {new Date().getFullYear()} Jérémy Couput · Conseiller SAFTI</p>
        </div>
      </div>
    </footer>;
}